import React from 'react';
import Glob from "../../../libs/Glob.mjs";
import "./AvvisiApp.css";
import AvvisiToolbar from "./AvvisiToolbar.mjs";
import AvvisiEditor from "./AvvisiEditor/AvvisiEditor.mjs";
import AvvisiItem from "./AvvisiItem.mjs";
import AvvisiPreview from "./AvvisiPreview.mjs";

const prefix = 'AvvisiApp';

const AvvisiApp = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notices: (Glob.getStatus('Game')?.notice||[]).reverse(),
		};
		this.uid = Glob.generateUid(prefix);
	}
	componentDidMount() {
		Glob.register('WriteNewAvviso', maildata => {
			Glob.trigger('OpenAvvisiEditor', { open: true, message: maildata });
		}, this.uid);
		Glob.register('NewNotice', notices =>{
			const n = (notices||[]).reverse();
			this.setState({notices: n });
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	render() {
		return (
			<div className={prefix} id={this.uid}>
				<AvvisiToolbar />
				<div className={"AvvisiBox"}>
					<div className={"AvvisiItems"}>
						{ this.state.notices.map(notice=> (
							<AvvisiItem
								key={notice.id}
								notice={notice}
								select={ ()=>{ this.setState({selected: (notice.id === this.state.selected?.id ? null : notice)} ) } }
							/>
						))}
					</div>
					<AvvisiPreview
						notice={ this.state.selected }
						close={ ()=>{ this.setState({selected: null }) } }
					/>
				</div>
				<AvvisiEditor />
			</div>
		)
	}
}

export default AvvisiApp;